import React from 'react';
import PropTypes from 'prop-types';
import { Form, Popup, Icon, List, Divider, Checkbox, Button, Dropdown, Grid, Card } from 'semantic-ui-react';
import { DateInput } from 'semantic-ui-calendar-react';



export class TableHeaderFilterColumn extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterByDate:props.filterByDate,
            filterByDropdown:props.filterByDropdown,
            filterByText:props.filterByText,
            filterByTextObject:props.filterByTextObject,
            datesRange: '',
            startDate: '',
            endDate: '',
            open: false,
            headerKey:'',
            selectedValue:''
        };
    }
    
    componentDidMount() {
        const { name } = this.props.filterByText;
        const {firstName}=this.props.filterByTextObject
        const {role,isActive}=this.props.filterByDropdown
        this.setState({
            headerKey: name || firstName ||'',
            selectedValue: role || isActive || ''
        });
    }
    // componentDidUpdate(prevProps, prevState) {
    //     // console.log("this.props in componentDidUpdate-=-=-=-> ",this.props);
    //     console.log("prevProps.filterByText in componentDidUpdate-=-=-=-> ",prevProps.filterByText);
    //     console.log("this.props.filterByText in componentDidUpdate-=-=-=-> ",this.props.filterByText);
    //     console.log("prevState.filterByText in componentDidUpdate-=-=-=-> ",prevState.filterByText);
    //     console.log("this.state.filterByText in componentDidUpdate-=-=-=-> ",this.state.filterByText);
    //     if (prevProps.filterByText !== this.props.filterByText) {
    //         console.log("ifififififififififiiiiiiiiiiiiiiiiiiii@@@@@@@@@@@@@@@@@@@@@inside if--------------------------------")
    //         const { name } = this.props.filterByText;
    //         const {firstName}=this.props.filterByTextObject
    //         const {role}=this.props.filterByDropdown
    //         console.log("name ",name)
    //         this.setState({
    //             headerKey: name || firstName || '',
    //             selectedValue:role || ''
    //         });
    //     console.log("this.state in ifffffffffffffffffffffffffffffff componentDidUpdate-=-=-=-> ",this.state);
    //     }
    //     console.log("this.state in componentDidUpdate-=-=-=-> ",this.state);

    // }

    
    //Change The Search Input Fields
    // handleOnChange = (event, data, type) => {
    //     console.log(data.name)
    //       if(data.name==='name'){
    //         this.setState({
    //              headerKey: data.value
    //         });
    //       }
    //       else{
    //         if(data.name==='firstName'){
    //             
    //       }
    //     }
    //     this.props.onSubmitFilter(data, this.props.type);

    //     if (this.props.headerClickHideResourcePane) {
    //         this.props.headerClickHideResourcePane()
    //     }
    // };

    handleOnChange = (event, data, type) => {
        if (data.name === 'name') {
            this.setState({
                filterByText: {
                    [data.name]: data.value
                },
                filterByTextObject: {
                    [data.name]: data.value
                },
                filterByDropdown: {
                    [data.name]: data.value
                },
                headerKey: data.value,
            });
        } else if (Array.isArray(data.name)) {
            const splitArr = data.value.split(' ', data.name.length); 
            this.setState(prevState => {
            const updatedFields = { ...prevState.filterByTextObject };
            data.name.forEach((fieldName, index) => {
                updatedFields[fieldName] = splitArr[index] || '';
            });
            const combinedValue = splitArr.join(' '); 
            return {
                     filterByTextObject: updatedFields,
                     headerKey: combinedValue,
                   };
            });
        } else {
            this.setState({
                filterByText: {
                    [data.name]: data.value
                },
                filterByTextObject: {
                    [data.name]: data.value
                },
                headerKey: data.value,
            });
        }
        this.props.onSubmitFilter(data, this.props.type); 
        if (this.props.headerClickHideResourcePane) {
            this.props.headerClickHideResourcePane();
        }
    };
    
    
    // Change The Date Of filter
    handleChangeDate = (event, { name, value }) => {
        event.stopPropagation()
        if (this.state.hasOwnProperty(name)) {
            this.setState({ [name]: value });
        }

        if (name === "startDate" && value.length === 0) {
            this.setState({ endDate: "" });
        }

        if (this.props.headerClickHideResourcePane) {
            this.props.headerClickHideResourcePane()
        }
    }

    // Apply The Date Filter
    applyDateFilter = (event) => {
        event.stopPropagation();
        let mixRange = `${this.state.startDate} - ${this.state.endDate}`;
        this.setState({ mixRange: mixRange })
        let dataFilterObj = {
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            name: this.props.headerKey,
            value: mixRange,
            filterby: 'date'
        }
        if (this.state.startDate && this.state.endDate) {
            this.props.onSubmitFilter(dataFilterObj, this.props.type);
            this.setState({ open: false })
        }
    }

    //Change Dropdown Items in Filters
    applyDropdownFilter = (event, data) => {
        event.stopPropagation();
      
        const value = data && data.value !== undefined ? data.value : null;
        const name = data.name;
      
        this.setState(prevState => ({
          filterByDropdown: {
            ...prevState.filterByDropdown,
            [name]: value 
          },
          open: false
        }));
      
        this.props.onSubmitFilter(data, this.props.type);
      
        if (this.props.headerClickHideResourcePane) {
          this.props.headerClickHideResourcePane();
        }
      };

    //Date Filter Open/Close Popup Model to add date filter and apply
    openPopup = () => {
        this.setState({ open: !this.state.open });
        if (this.props.headerClickHideResourcePane) {
            this.props.headerClickHideResourcePane()
        }
    }

    //Close popup model of date filter
    closeDateFilter = () => {
        this.setState({ open: false });
        this.setState({
            startDate: "",
            endDate: "",
        })
    }

    //clear date filter 
    clearDateRange = (e, data) => {
            this.setState({
            startDate: "",
            endDate: "",
            mixRange: "",
        })

        let clearData = {
            value: null,
            filterby: 'date',
            startDate: null,
            endDate: null,
            name: data.headerkey,
        }
        this.props.onSubmitFilter(clearData, 'Single Search')
    }

    //Clear input search items
    clearInput = (e, data) => {
        this.setState({
            [data.headerkey]: '',
        });
        let clearData = {
            name: data.headerkey,
            firstName: data.headerkey,
            value: null,
            filterby: 'text'
        }
        this.props.onSubmitFilter(clearData, 'Single Search')
    }

    render() {
        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });

        this.props.item.keyValue && this.props.item.keyValue.sort((a, b) => {
            return collator.compare(a.text, b.text)
        })

        let emptySelect = [{ text: "Select", value: null }]
        let noValue = [{ text: "No Data Available", value: null, content: (<span className="clr-red" >No Data Available</span>) }]

        let setkeyValue = this.props.item.keyValue ? emptySelect.concat(this.props.item.keyValue) : noValue



        let dropdownOptions = setkeyValue
            .map((v, i) => {
                v.children && delete v.children;
                v.text = v.text;
                v.value = v.value;
                return v
            })


        return this.props.item && (this.props.item.key === "createdAt" || this.props.item.key === "updatedAt") ?
            <React.Fragment>
                <Popup
                    trigger={
                        <Form.Input
                            placeholder={this.props.headerName}
                            name="date"
                            fluid
                            value={this.state.mixRange}
                            onFocus={this.openPopup}
                            className="filter-search"
                            icon={
                                this.state.mixRange ?
                                    this.state.mixRange !== '' ?
                                        <Icon
                                            name='delete'
                                            link
                                            onClick={this.clearDateRange}
                                            headerkey={this.props.headerKey}
                                        /> :
                                        "calendar alternate outline" :
                                    "calendar alternate outline"}
                        />
                    }
                    position="bottom right"
                    className="pad_0 "
                    open={this.state.open}
                    style={{ zIndex: 99999 }}
                >
                    <Popup.Content >
                        <Card style={{ width: "530px" }}>
                            <Card.Header className="pad_10 ">Select Range
                                <Icon name="close" onClick={this.closeDateFilter} className="float-right cursor-pointer" />
                            </Card.Header>
                            <Card.Content >
                                <Grid columns="equal" >
                                    <Grid.Row className="pad_0 ">
                                        <Grid.Column className="pad_5 ">
                                            <h3 style={{ margin: "0px 0 5px 0" }}>From</h3>
                                            <DateInput
                                                maxDate={this.state.endDate}
                                                name="startDate"
                                                placeholder="Start Date"
                                                value={this.state.startDate}
                                                iconPosition="right"
                                                animation='none'
                                                onChange={this.handleChangeDate}
                                                clearable={true}
                                                closable
                                                inline
                                            />
                                        </Grid.Column>
                                        <Grid.Column className="pad_5 ">
                                            <h3 style={{ margin: "0px 0 5px 0" }}>To</h3>
                                            <DateInput
                                                minDate={this.state.startDate}
                                                name="endDate"
                                                placeholder="End Date"
                                                value={this.state.endDate}
                                                iconPosition="right"
                                                animation='none'
                                                onChange={this.handleChangeDate}
                                                clearable={true}
                                                closable
                                                initialDate={this.state.startDate}
                                                inline
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Card.Content>
                            <Card.Content extra>
                                <Button
                                    size="mini"
                                    disabled={this.state.startDate.length === 0 || this.state.endDate.length === 0}
                                    fluid
                                    className={this.state.startDate.length === 0 || this.state.endDate.length === 0 ? "bg-gray" : "bg-blue"}
                                    onClick={(e) => this.applyDateFilter(e)}>Apply</Button>
                            </Card.Content>
                        </Card>
                        {/* <List divided verticalAlign='middle' >
                            <List.Item style={{ padding: "5px 10px" }}>
                                <List.Content floated='right'>
                                    <Icon name="close" onClick={this.closeDateFilter} />
                                </List.Content>
                                <List.Content >
                                    <b> Select Range</b>
                                </List.Content>
                            </List.Item>
                            <List.Item className="pad_10 calander-popup" >
                                <h3 style={{ margin: "0px 0 5px 0" }}>From</h3>
                                <DateInput
                                    maxDate={this.state.endDate}
                                    name="startDate"
                                    placeholder="Start Date"
                                    value={this.state.startDate}
                                    iconPosition="right"
                                    animation='none'
                                    onChange={this.handleChangeDate}
                                    clearable={true}
                                    closable
                                    inline
                                />
                            </List.Item>
                            {this.state.startDate.length === 0 ? null :
                                <List.Item className="pad_10 calander-popup">
                                    <h3 style={{ margin: "0px 0 5px 0" }}>To</h3>
                                    <DateInput
                                        minDate={this.state.startDate}
                                        name="endDate"
                                        placeholder="End Date"
                                        value={this.state.endDate}
                                        iconPosition="right"
                                        animation='none'
                                        onChange={this.handleChangeDate}
                                        clearable={true}
                                        closable
                                        initialDate={this.state.startDate}
                                        inline
                                    />
                                </List.Item>}
                            <List.Item style={{ padding: "5px 10px" }}>
                                <List.Content >
                                    <Button
                                        size="mini"
                                        disabled={this.state.startDate.length === 0 && this.state.endDate.length === 0}
                                        fluid
                                        className={this.state.startDate.length === 0 && this.state.endDate.length === 0 ? "bg-gray" : "bg-blue"}
                                        onClick={(e) => this.applyDateFilter(e)}>Apply</Button>
                                </List.Content>
                            </List.Item>
                        </List> */}
                    </Popup.Content>
                </Popup>
            </React.Fragment>
            :

            this.props.item.dropdown ?
                <Dropdown
                    className="tableFilterDropdown"
                    placeholder={this.props.headerName}
                    fluid
                    disabled={this.props.item.disabled}
                    selection
                    options={dropdownOptions}
                    name={this.props.headerKey}
                    //value={this.state.selectedValue || ''}
                    value={this.state.filterByDropdown[this.props.headerKey]}
                    onChange={this.applyDropdownFilter}
                    filterby="dropdown"
                    clearable
                    pointing
                />
                : this.props.item.key === "action" ?
                    <Popup
                        on='click'
                        trigger={<Icon className="float-right table-add-btn custom-settings-icon" style={{ height: "11px", width:"12.97px" }} />}
                        position="bottom right"
                        className="pad_0"
                        style={{
                            display: "block",
                            overflow: "auto",
                            maxHeight: "200px",
                            background: "white"
                        }}
                    >
                        <Popup.Content>
                            <List divided verticalAlign='middle' >
                                <List.Item className="pad_10">
                                    <List.Content as="h3" >
                                        Add Column
                                    </List.Content>
                                </List.Item>
                            </List>
                            <Divider className="mar_0" />
                            <List divided verticalAlign='middle'  >
                                {this.props.tableHeader &&
                                    this.props.tableHeader.filter((filtr, i) => {
                                        return filtr.key !== "action" && i >= 1
                                    }).map((listItems, i) => {
                                        return <List.Item key={i} className="pad_10">
                                            <List.Content >
                                                <Checkbox
                                                    key={i}
                                                    name={listItems.name}
                                                    label={listItems.name}
                                                    checked={listItems.listed}
                                                    onChange={(e, data) => this.props.addColumn(e, i, listItems)} />
                                            </List.Content>
                                        </List.Item>
                                    })}
                            </List>
                        </Popup.Content>
                    </Popup> :
                    <Form.Input
                        key={this.props.headerName}
                        placeholder={this.props.headerName}
                        name={this.props.headerKey}
                        //value={this.state[this.props.headerKey]}
                        value={this.state.headerKey}
                        onChange={this.handleOnChange}
                        className="filter-search"
                        filterby="text"
                        // autoFocus
                        fluid
                        icon={this.state[this.props.headerKey] ?
                            this.state[this.props.headerKey] !== '' ?
                                <Icon
                                    name='delete'
                                    link
                                    onClick={this.clearInput}
                                    headerkey={this.props.headerKey} /> :
                                "search" :
                            "search"
                        }
                    />

    }
}

TableHeaderFilterColumn.propTypes = {
    onSubmitFilter: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    totalCount: PropTypes.number.isRequired,
    headerClickHideResourcePane: PropTypes.func.isRequired,
};
